import { useEffect, useRef, useState } from 'react';

export function useBelotHeroTurnTimer({
  sessionStarted,
  roundDealAnimActive,
  engineState,
  humanSeat,
  turnSeconds,
  stateRef,
  apply,
  pickPlayCmdForSeatRef,
  belotCardIsTrump,
  play,
}) {
  const [heroSecLeft, setHeroSecLeft] = useState(null);
  const prevHeroTimedTurnRef = useRef(false);

  const heroTimedTurn =
    sessionStarted &&
    !roundDealAnimActive &&
    ((engineState.phase === 'auction' && engineState.currentTurnSeat === humanSeat) ||
      (engineState.phase === 'play' && engineState.currentTurnSeat === humanSeat));

  useEffect(() => {
    if (!heroTimedTurn) {
      setHeroSecLeft(null);
      return undefined;
    }

    setHeroSecLeft(turnSeconds);
    const interval = window.setInterval(() => {
      setHeroSecLeft((s) => (s == null || s <= 1 ? 0 : s - 1));
    }, 1000);

    const kill = window.setTimeout(() => {
      const s = stateRef.current;
      const auctionTurn = s.phase === 'auction' && s.currentTurnSeat === humanSeat;
      const playTurn = s.phase === 'play' && s.currentTurnSeat === humanSeat;
      if (!auctionTurn && !playTurn) return;

      if (auctionTurn) {
        apply({ type: 'PASS', seat: humanSeat });
      } else if (playTurn) {
        const cmd = pickPlayCmdForSeatRef.current?.(s, humanSeat);
        if (cmd) {
          apply(cmd);
          const tr = s.contract?.trumpSuit;
          const cr = cmd.payload?.card;
          const isTr = cr != null && tr != null && belotCardIsTrump(tr, cr);
          play(isTr ? 'belot-card-table-trump' : 'belot-card-table', 0.78);
        }
      }
      setHeroSecLeft(null);
    }, turnSeconds * 1000);

    return () => {
      window.clearInterval(interval);
      window.clearTimeout(kill);
    };
  }, [
    heroTimedTurn,
    engineState.phase,
    engineState.currentTurnSeat,
    engineState.trickIndex,
    turnSeconds,
    stateRef,
    apply,
    play,
    pickPlayCmdForSeatRef,
    belotCardIsTrump,
    humanSeat,
  ]);

  useEffect(() => {
    if (heroTimedTurn && !prevHeroTimedTurnRef.current) {
      play('your-turn', 0.82);
    }
    prevHeroTimedTurnRef.current = heroTimedTurn;
  }, [heroTimedTurn, play]);

  return { heroSecLeft, heroTimedTurn, prevHeroTimedTurnRef };
}

